
































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { validationMixin } from 'vuelidate';

import { mixins } from 'vue-class-component';
import { Tank, TanksApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import { AxiosError } from 'axios';
import { Validations } from 'vuelidate-property-decorators';
import { minLength, minValue, required } from 'vuelidate/lib/validators';

@Component({
	components: {},
	methods: {},
	mixins: [validationMixin],
})
export default class AddTank extends mixins(validationMixin) {
	@Prop(Number)
	public productId!: number;
	@Prop(Array)
	public tanks!: [];

	public fuelTypes = [];

	public newTank = {
		name: '',
		nominalVolume: undefined,
		fuelType: '',
	};

	public async created() {
		await this.fetchFuelTypes();
	}
	public updateFuelTankName() {
		if (this.$v.newTank.nominalVolume.$dirty && this.$v.newTank.fuelType.$dirty) {
			this.$v.newTank.name.$touch();
			this.newTank.name = `${this.$options.filters.capitalise(this.newTank.fuelType)} | ${
				this.newTank.nominalVolume
			}L`;
		}
	}
	@Validations()
	public validations() {
		return {
			newTank: {
				name: {
					required,
					minLength: minLength(1),
					unique: this.isNameUnique(this.newTank.name),
					$autoDirty: true,
				},
				fuelType: { required, $autoDirty: true },
				nominalVolume: {
					required,
					$autoDirty: true,
					minValue: minValue(1),
				},
			},
		};
	}

	public isNameUnique(name: string | null) {
		return (
			name == null ||
			this.tanks.findIndex(entity =>
				entity.name ? entity.name.toLowerCase() : 'null' === name.toLowerCase(),
			) === -1
		);
	}

	public async addNewFuelTank(e: any) {
		this.$v.newTank.$touch();

		if (this.isValid(this.$v.newTank) === true) {
			await this.addTank(this.newTank);
			this.$emit('loadProduct');
			this.TankModalClosed();
		} else {
			e.preventDefault();
			return;
		}
	}

	public isValid(field) {
		if (field && field.$dirty) {
			return !field.$invalid;
		} else {
			return null;
		}
	}

	private async fetchFuelTypes(): Promise<void> {
		try {
			const fuelTypesResponse = await this.axios.get<Array<{ type: string; label: string }>>(
				process.env.VUE_APP_API_URL + `/tanks/fuelTypes`,
			);
			this.fuelTypes = fuelTypesResponse.data.data;
		} catch (errorResponse) {
			const error = errorResponse as AxiosError;
		}
	}

	public TankModalClosed() {
		this.newTank = {
			name: '',
			nominalVolume: undefined,
			fuelType: '',
		};
		this.$v.$reset();
	}

	public async addTank(tank: Tank) {
		tank.productId = this.productId;
		tank.type = 'aws';
		let response;
		try {
			response = await new TanksApi().addTank({ data: tank }).then(
				(this.newTank = {
					nominalVolume: undefined,
					name: '',
					fuelType: '',
				}),
				new Toast().makeToast('Tank Added', 'Successfully', 'success'),
				setTimeout(() => {
					this.$emit('loadProduct');
				}, 1000),
			);
		} catch (e) {
			const error = 'Tank not created ' + e.response.data.errors;
			new Toast().makeToast(error, 'Error Adding Tank', 'danger', true);
			return;
		}
	}
}
